import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [ticketIds, setTicketIds] = useState([]);
  const [notify, setNotify] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          setTicketIds(r.data.ticket_ids || []);
          setNotify({ result: r.data.notify_result || {}, email: r.data.email, phone: r.data.phone });
          const existing = JSON.parse(localStorage.getItem("my_tickets") || "[]");
          const merged = Array.from(new Set([...existing, ...(r.data.ticket_ids || [])]));
          localStorage.setItem("my_tickets", JSON.stringify(merged));
          return;
        }
      } catch (e) { /* ignore */ }
      attempts++;
      if (attempts < 20) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0B0C10] text-slate-100 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-[#00E676] mx-auto" />
            <h1 className="mt-6 text-4xl font-black" style={{ fontFamily: "Unbounded, sans-serif" }}>Betaling gelukt!</h1>
            <p className="mt-3 text-slate-400">Je bingokaart{ticketIds.length > 1 ? "en zijn" : " is"} klaar. Veel succes!</p>
            {notify && (notify.result.email || notify.result.sms) && (
              <div className="mt-4 text-sm space-y-1" data-testid="notify-status">
                {notify.result.email === "sent" && <div className="text-[#00E676]">✉ Kaartlink gemaild naar <b>{notify.email}</b></div>}
                {notify.result.email === "failed" && <div className="text-[#FFD700]">✉ E-mail kon niet worden verzonden — bewaar de link hieronder.</div>}
                {notify.result.sms === "sent" && <div className="text-[#00E676]">📱 SMS verstuurd naar <b>{notify.phone}</b></div>}
                {notify.result.sms === "failed" && <div className="text-[#FFD700]">📱 SMS kon niet worden verzonden — bewaar de link hieronder.</div>}
              </div>
            )}
            <div className="mt-8 space-y-2">
              {ticketIds.map((tid) => (
                <button key={tid} onClick={() => nav(`/viewer/play/${tid}`)}
                        data-testid={`success-open-${tid}`}
                        className="w-full p-4 rounded-xl bg-[#12141D] border border-[#FFD700]/30 hover:border-[#FFD700] transition text-left">
                  <div className="font-mono text-xs text-slate-400">{tid.slice(0, 8)}...</div>
                  <div className="text-[#FFD700] font-bold mt-1">Open kaart →</div>
                </button>
              ))}
            </div>
          </>
        ) : status === "timeout" ? (
          <>
            <h1 className="text-2xl font-black text-[#FF1744]">Betaling nog niet bevestigd</h1>
            <p className="mt-3 text-slate-400">Probeer de pagina te verversen.</p>
          </>
        ) : (
          <>
            <div className="w-12 h-12 border-4 border-[#FFD700]/30 border-t-[#FFD700] rounded-full animate-spin mx-auto" />
            <p className="mt-6 text-slate-400 uppercase tracking-widest text-sm">Betaling controleren...</p>
          </>
        )}
        <Link to="/viewer" className="mt-8 inline-block text-sm text-slate-500 hover:text-slate-300">← Terug</Link>
      </div>
    </div>
  );
}
